import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { UpArrowIconSmall } from 'src/ui/assets/icons/arrow/UpArrowIconSmall';
import { Button } from 'src/ui/components/button/common/Button';
import { withConfig } from 'src/withConfig';

type SectionHeaderWrapperType = {
    isOpen: boolean;
    variant: DefaultComponentVariantType | null;
    type: 'default' | 'header';
}

export const CollapseWrapper = withConfig(theme => styled('div', { label: 'CollapseWrapper' })<SectionHeaderWrapperType>`
    align-items: center;
    cursor: ${({type}) => type ==='default' ? 'pointer' : 'default'};
    display: flex;
    flex-flow: row nowrap;
    gap: 8px;
    justify-content: start;
    position: relative;
    ${({ isOpen }) => isOpen === false ? `border-bottom: 1px solid ${theme.star.unified.collapse.borderColor}` : ''};

    &[type='header'] {
        background: ${theme.star.unified.collapse.bgColor};
        color: ${theme.star.unified.collapse.txtColor};
        & [class$='CollapseLabel'] {
            padding: 12px;
        }
        & [class$='SectionTitle'] {
            font-size: ${theme.star.fontSize.regular};
            line-height: ${theme.star.lineHeight[300]};
            width: 100%;
        }
    }
    &[type='default'] {
        background: ${theme.star.unified.collapse.bgColorTertiary};
        color: ${theme.star.unified.collapse.txtColorSecondary};
  
        & [class$='CollapseLabel'] {
            padding: 8px 12px;
        }
        & [class$='SectionTitle'] {
            font-size: ${theme.star.fontSize.xRegular};
            line-height: 1.428;
        }

        &.event-group-header--6-pack {
            background: ${theme.star.unified.eventHeaderCaption.bgColor};

            & [class$='CollapseLabel'] {
                color: ${theme.star.unified.eventHeaderCaption.txtColor};
            }

            & [class$='SectionTitle'],
            & [class$='EventHeaderGroupSelection'] {
                font-size: ${theme.star.fontSize.small};
                font-weight: ${theme.star.fontWeight.regular};
                line-height: 1.3334;
            }
            & [class$='EventHeaderGroupSelection'] {
                color: ${theme.star.unified.eventHeaderCaption.txtColorSecondary};
            }
        }
    }
`);

export const CollapseLabel = styled('div', { label: 'CollapseLabel' })`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 8px;
    justify-content: space-between;
    overflow: hidden;
`;

export const SectionTitle = withConfig(theme => styled('h4', { label: 'SectionTitle' })`
    align-items: center;
    display: flex;
    font-weight: ${theme.star.fontWeight.bold};
    gap: 8px;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    white-space: nowrap;
`);

const setSize = (size: number = 16): SerializedStyles => {
    return css`
        flex: 0 0 ${size}px;
        width: ${size}px;
    `;
};

export const ChevronWrapper = withConfig(theme => styled(UpArrowIconSmall, { label: 'ChevronWrapper' })<{size?: number}>`
    fill: ${theme.star.collapse.competitionAndMarket.bgColorSecondary};
    ${({ size }) => setSize(size)};
`);

export const CollapseChildren = styled('div', { label: 'CollapseChildren' })`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    align-self: stretch;
`;

export const SeeMoreButton = styled(Button, { label: 'SeeMoreButton' })`
    margin-left: auto;
`;
